import {finalize, tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const started = Date.now();
    let ok: string;

    return next.handle(req)
      .pipe(
        tap(
          event => {
            ok = event instanceof HttpResponse ? 'succeeded' : '';
          },
          error => ok = 'failed'
        ),
        // Log when response observable either completes or errors
        finalize(() => {
          const elapsed = Date.now() - started;
          const msg = `${req.method} "${req.urlWithParams}",  ${ok} in ${elapsed} ms.`;
          console.log('logger', msg);
          // this.messenger.add(msg);
        }),
      );
  }
}
